import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    desktopContainer: {
      '@media (max-width: 1180px)': {
        display: 'none',
      },
    },
    filters: {
      flexGrow: 0,
      maxWidth: '45%',
      flexBasis: '45%',
    },
    mobileContainer: {
      '@media (min-width: 1181px)': {
        display: 'none',
      },
    },
    dialog: {
      width: 343,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
  }),
);
